import styled, { css } from "styled-components";


export const Container = styled.div`
`

export const QuadroHeader = styled.div`
  background: #EEEEEE;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 12px;
  padding: 12px;
  position: sticky;
  top: -17px;
  font-size: .9rem;

  @media (max-width: 800px) {
    padding-inline: 25px;
  }
`


export const HeaderRotulo = styled.span`
  color: ${props => props.theme.colors.primary};
  font-weight: bold;
`


export const HeaderValor = styled.span`
  :not(:last-child){
    :after{
      content: '|';
      color: ${props => props.theme.colors.primary};
      margin-left: 12px;
    }
  }
  
`

export const Tabela = styled.table`
  width: 100%;
  margin: 15px 0 20px;
  text-align: left;
  table-layout: auto;
  font-size: .9rem;
  display: table;
  
  
  th{
    font-weight: 500;
    vertical-align: middle;
  }
  
  tr {
    width: 100%;
  }
  
  th, td {
    padding: 10px 15px;
  }
  
  td{
    color: ${props => props.theme.colors.halfOpacityBlack};
  }
  
  @media (max-width: 1190px) {
    font-size: .8rem;

    th, td {
      padding-inline: 10px;
    }
  }

  th:first-child, td:first-child{
    text-align: center;
    padding-right: 10px;
  }


  
`

export const LinhaFiltros = styled.div`
  display: flex;
  flex-wrap: wrap;
  width: 100%;
  gap: 25px;
  padding: 20px 0;

  @media (max-width: 800px) {
    justify-content: space-between;
  }
`


export const LinhaSkeleton = styled.div`
  display: grid;
  grid-template-columns: 1fr 2fr 4fr 4fr 2fr 4fr 4fr;
  gap: 4px;
  padding: 10px 0;
`


export const MensagemContainer = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;
  color: ${props => props.theme.colors.halfOpacityBlack};
  padding: 30px 0 50px;

`


interface IDropdownProps {
  width?: number;
}

const inputStyle = css`
-webkit-appearance: none;
	appearance: none;
  border: none;
  border-radius: 8px;
  background: #fff !important;
  padding: 7px 15px;
  width: 145px;
  height: 32.800px;
  display: flex;
  justify-content: space-between;
  box-shadow: rgba(100, 100, 111, 0.2) 0px 7px 29px 0px;
  outline: none;
  color: rgba(0,0,0,.5);
`



export const DropDown = styled.div<IDropdownProps>`
  ${inputStyle}
  ${props => props.width ? `width: ${props.width}px;` : ''}
  
  :hover{
    cursor: pointer;
  }

  display: flex;
  align-items: center;

  span{
    color: rgba(0,0,0,.5);
    text-overflow: ellipsis;
    overflow: hidden; 
    white-space: nowrap;
    font-size: .75rem;
  }
`

interface IInputProps {
  width?: number
  invalid?: boolean
}

export const DateInput = styled.input<IInputProps>`
  ${inputStyle}
  width: ${props => props.width ? props.width : 200}px;

  	&::-webkit-date-and-time-value {
		text-align: left;
	}

 border: 1px solid transparent;

  ${props => props.invalid && `
    border: 1px solid red;
  `}
`